export default {
    embassy: 'Посольство Франции в Российской Федераций',
    address: 'ул. Б. Якиманка, 45 115127 Москва',
    contacts: 'Контакты',
    department: 'Отдел стипендий',
    supported: 'При поддержке Правительства Франции'
}